import { i18nFilter } from "app/filters/i18nFilter";

const KEYWORD_DIFFICULTY_TEXT_KEY = "common.filters.keyword.difficulty.range.filter.title";
const KEYWORD_DIFFICULTY_TEXT_AT_LEAST_KEY = "common.filters.keyword.difficulty.range.filter.at.least";
const KEYWORD_DIFFICULTY_TEXT_AT_UP_TO_KEY = "common.filters.keyword.difficulty.range.filter.up.to";

export const getKeywordDifficultyFilterText = (
    difficultyFromValue: number | undefined,
    difficultyToValue: number | undefined,
    filterRangeLowerLimit: number,
    filterRangeUpperLimit: number,
) => {
    const i18n = i18nFilter();

    if (!difficultyFromValue && !difficultyToValue) {
        return null;
    }
    const shouldShowRangeFilterText =
        difficultyFromValue !== filterRangeLowerLimit && difficultyToValue !== filterRangeUpperLimit;
    if (shouldShowRangeFilterText) {
        return i18n(KEYWORD_DIFFICULTY_TEXT_KEY, {
            from: difficultyFromValue,
            to: difficultyToValue,
        });
    }
    const shouldShowAtLeastText =
        difficultyFromValue !== filterRangeLowerLimit && difficultyToValue === filterRangeUpperLimit;
    if (shouldShowAtLeastText) {
        return i18n(KEYWORD_DIFFICULTY_TEXT_AT_LEAST_KEY, { value: difficultyFromValue });
    }
    const shouldShowUpToText =
        difficultyFromValue === filterRangeLowerLimit && difficultyToValue !== filterRangeUpperLimit;
    if (shouldShowUpToText) {
        return i18n(KEYWORD_DIFFICULTY_TEXT_AT_UP_TO_KEY, { value: difficultyToValue });
    }
};
export const getSelectedRangeLimits = (
    difficultyFromValue: number,
    difficultyToValue: number,
    rangeLimits: [number, number],
): [number, number] => {
    return !!difficultyFromValue && !!difficultyToValue ? [difficultyFromValue, difficultyToValue] : rangeLimits;
};
